<!-- This shows when the subscription is canceled  -->
<template>
  <div class="">

       <!-- Subscription Type -->
      <br />
      <v-card>
       <v-card-title primary-title>
           <div>
             Your subscription is canceled.
             You can still restart your subscription without losing data.
           </div>
       </v-card-title>

       <v-card-actions color="accent">
         <v-spacer></v-spacer>
         <div v-if="inprogress">
           Working...
           <v-progress-circular
           indeterminate
           color="primary"
           ></v-progress-circular>
         </div>
         <div v-else>
            <v-btn @click="show = !show" flat color="accent">
             Restart Subscription
             <v-icon class="ml-1">{{show ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>

            </v-btn>
         </div>

       </v-card-actions>

       <v-slide-y-transition>
         <v-card-text v-show="show">
           <form action="/restartSubscription" method="post" id="restart-subscription-form">

             <div class="subheading">
               Credit or debit card
             </div>
             <v-layout align-center justify-center row fill-height>

               <v-flex creditcard sm10 xs12 id="card-element-restart-sub">
                 <!-- A Stripe Element will be inserted here. -->
               </v-flex>
             </v-layout>

             <!-- Used to display form errors. -->
             <div id="card-errors" class='error--text' role="alert"></div>

             <br />
             <v-layout row>
               <v-spacer></v-spacer>
               <v-btn type='submit' :disabled="inprogress" class="success" :loading="inprogress">
                 Resubscribe
               </v-btn>
             </v-layout>
             <v-layout row class="error--text" v-if="errMessage">
               <v-spacer></v-spacer>
               <span>{{ errMessage }}</span>
             </v-layout>
             <v-layout row class="heading success--text " v-if="updateSuccess">
               <v-spacer></v-spacer>
               <span>Subscription created successfully</span>
             </v-layout>

         </form>

         </v-card-text>
       </v-slide-y-transition>

      </v-card>

</div>

</template>

<script>

import config from '../../../config.js'
import {mapState} from 'vuex'

export default {
  name: 'SubscriptionCardCanceled',
  components: {
  },
  computed: {
    ...mapState({
      name: state => state.admin.userInfo.name,
      subscriptionID: state => state.admin.data_ro.subscriptionID,
      planName: state => state.admin.data_ro.planName
    })

  },
  props: {

  },
  data () {
    return {
      show: false,
      inprogress: false,
      errMessage: null,
      updateSuccess: false
    }
  },
  mounted: function () {
    const stripe = window.Stripe(config.stripePublishableKey)
    const elements = stripe.elements()

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    }

    // Create an instance of the card Element.
    var card = elements.create('card', {style: style})

    // Add an instance of the card Element into the `card-element` <div>.
    card.mount('#card-element-restart-sub')

    // Handle real-time validation errors from the card Element.
    card.addEventListener('change', function (event) {
      var displayError = document.getElementById('card-errors')
      if (event.error) {
        displayError.textContent = event.error.message
      } else {
        displayError.textContent = ''
      }
    })

    // Handle form submission.
    var form = document.getElementById('restart-subscription-form')
    form.addEventListener('submit', (event) => {
      event.preventDefault()

      this.updateSuccess = false
      this.inprogress = true
      this.errMessage = null
      stripe.createToken(card).then((result) => {
        if (result.error) {
          this.inprogress = false
          // Inform the user if there was an error.
          var errorElement = document.getElementById('card-errors')
          errorElement.textContent = result.error.message
        } else {
          // Send the token to your server.
          this.stripeTokenHandler(result.token)
        }
      })
    })
  },
  methods: {

    stripeTokenHandler: async function (stripeToken) {
      // This function wll create and charge the account
      try {
        // Now link them and charge the account

        var restartSubscription = config.getFunctions().httpsCallable('restartSubscription')
        await restartSubscription(
          {
            stripeToken: stripeToken
          }
        )

        this.inprogress = false

        // If all went well, we're logged in as the kid, go to their account
        this.updateSuccess = true
      } catch (err) {
        console.error('ERROR : ' + JSON.stringify(err))
        this.errMessage = err.message
        this.inprogress = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
